const CONTINUITY_ONBOARDING_STEP = 'continuityOnboardingStep';

const steps = [
  'members',
  'depositor',
  'beneficiary',
  'notification-settings',
  'activation-notifications',
  'environment-visibility',
  'agreement-setup',
  'agreement-details',
  'summary',
] as const;

export type IOnboardingStep = (typeof steps)[number];

export const getContinuityOnboardingStep = (continuityId: string): IOnboardingStep | null => {
  const step = localStorage.getItem(`${CONTINUITY_ONBOARDING_STEP}-${continuityId}`) as IOnboardingStep;

  return steps.includes(step) ? step : null;
};

export const setContinuityOnboardingStep = (continuityId: string, step: IOnboardingStep) =>
  localStorage.setItem(`${CONTINUITY_ONBOARDING_STEP}-${continuityId}`, step);

export const resetContinuityOnboardingStep = (continuityId: string) =>
  localStorage.removeItem(`${CONTINUITY_ONBOARDING_STEP}-${continuityId}`);
